// Small shared UI helpers for the client dashboard.

// True when the OS/browser asks for reduced motion.
export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;

// Scroll behaviour that honours the motion preference.
export const scrollBehavior = () => (prefersReducedMotion() ? 'auto' : 'smooth');
